import { render, staticRenderFns } from "./order-warn.vue?vue&type=template&id=4c04e09c&scoped=true&"
import script from "./order-warn.vue?vue&type=script&lang=js&"
export * from "./order-warn.vue?vue&type=script&lang=js&"
import style0 from "./order-warn.vue?vue&type=style&index=0&id=4c04e09c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c04e09c",
  null
  
)

export default component.exports